import { render, staticRenderFns } from "./confirm-b.vue?vue&type=template&id=b5e08a96&scoped=true&lang=pug&"
import script from "./confirm-b.vue?vue&type=script&lang=js&"
export * from "./confirm-b.vue?vue&type=script&lang=js&"
import style0 from "./confirm-b.vue?vue&type=style&index=0&id=b5e08a96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e08a96",
  null
  
)

export default component.exports